import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import HomePage from './components/HomePage';
import CarSelection from './components/CarSelection';
import OilSelection from './components/OilSelection';
import SchedulingAndLocation from './components/SchedulingAndLocation';
import ReservationSummary from './components/ReservationSummary';
import ReservationSuccess from './components/ReservationSuccess';
import './i18n';
import Welcome from './components/Welcome';
import Discover from './components/Discover';
import IndexV2 from './v2';

interface CarDetails {
  brand: string;
  model: string;
  engine: string;
  id_brand: number; 
}
interface PricingDetails {
  oil_price: { [key: string]: number };
  oil_filter_price: number;
  oil_capacity: string,
  oil_grade: string,
  air_filter_price?: number;
  fuel_filter_price?: number;
  labor_price: number;
  travel_price: number;
}
interface OilDetails {
  brand: string;
}

interface SchedulingDetails {
  date: string;
  time: string;
  quartier: string;
}

interface OrderDetails {
  carModel: string;
  serviceType: 'simple' | 'complete';
  oilBrand: string;
  pricing: PricingDetails | undefined;
  client_name: string | null;
  phone: string | null;
  schedulingDetails: SchedulingDetails;
  id_brand?: number; 
  orderNumber?: string; 
};

const App: React.FC = () => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(1);
  const [serviceType, setServiceType] = useState<'simple' | 'complete' | null>(null);
  const [carDetails, setCarDetails] = useState<CarDetails | null>(null);
  const [pricingDetails, setPricingDetails] = useState<PricingDetails | undefined>();
  const [oilDetails, setOilDetails] = useState<OilDetails | null>(null);
  const [schedulingDetails, setSchedulingDetails] = useState<SchedulingDetails | null>(null);
  const [finalDetails, setFinalDetails] = useState<OrderDetails | null>(null);
  const [loading, setLoading] = useState(false);

  const handleHomeNextStep = (type: 'simple' | 'complete') => {
    setLoading(true);

    setTimeout(() => {
      setServiceType(type);
      setCurrentStep(2);
      setLoading(false);
    }, 500);
  };

  const handleCarSelectionNextStep = (details: CarDetails) => {
    setCarDetails(details);
    setCurrentStep(3);
  };

  const handleOilSelectionNextStep = (details: OilDetails,pricing : PricingDetails | undefined) => {
    setOilDetails(details);
    setPricingDetails(pricing);
    setCurrentStep(4);
  };

  const handleSchedulingNextStep = (details: SchedulingDetails) => {
    setSchedulingDetails(details);
    setCurrentStep(5);
  };

  const handleReservationComplete = (details: OrderDetails & { orderNumber?: string  | undefined; }) => {
    setFinalDetails(details);
    setCurrentStep(6);
  };

  const handleBackStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <HomePage onNextStep={handleHomeNextStep} loading={loading} />;
      case 2:
        return serviceType ? (
          <CarSelection 
            serviceType={serviceType} 
            onNextStep={handleCarSelectionNextStep} 
            onBackStep={handleBackStep} 
          />
        ) : (
          <HomePage onNextStep={handleHomeNextStep} loading={loading} />
        );
      case 3:
        return carDetails ? (
          <OilSelection 
            carDetails={carDetails} 
                  //@ts-ignore

            serviceType={serviceType!}
            onNextStep={handleOilSelectionNextStep} 
            onBackStep={handleBackStep} 
          />
        ) : (
          <CarSelection 
            serviceType={serviceType!} 
            onNextStep={handleCarSelectionNextStep} 
            onBackStep={handleBackStep} 
          />
        );
      case 4:
        return oilDetails ? (
          <SchedulingAndLocation 
            onNextStep={handleSchedulingNextStep} 
            onBackStep={handleBackStep} 
          />
        ) : (
          <OilSelection 
            carDetails={carDetails!} 
                  //@ts-ignore
            serviceType={serviceType!}
            onNextStep={handleOilSelectionNextStep} 
            onBackStep={handleBackStep} 
          />
        );
      case 5:
        return schedulingDetails && serviceType && carDetails && oilDetails ? (
          <ReservationSummary
            serviceDetails={{
              carModel: `${carDetails.brand} ${carDetails.model}`,
              serviceType,
              schedulingDetails,
              phone: null,
              client_name: null,
              oilBrand: oilDetails.brand,
              pricing: pricingDetails,
              id_brand: carDetails.id_brand
            }}
            onNextStep={handleReservationComplete}
            onBackStep={handleBackStep}
          />
        ) : (
          <SchedulingAndLocation 
            onNextStep={handleSchedulingNextStep} 
            onBackStep={handleBackStep} 
          />
        );
      case 6:
        return <ReservationSuccess serviceDetails={finalDetails} />;
      default:
        return <HomePage onNextStep={handleHomeNextStep} loading={loading} />;
    }
  };

  return (
    <BrowserRouter>
    <Routes>
      <Route path="/reservation" element={    <MainLayout currentStep={currentStep}>
      {renderStep()}
    </MainLayout>} />
    <Route path="/reservation/show" element={    <MainLayout currentStep={currentStep}>
      {renderStep()}
    </MainLayout>} />
      <Route path="/discover" element={<Discover />} />
      <Route path="/" element={<Welcome />} />
      <Route path="/v2" element={<IndexV2 />} />
   {/*    <Route path="*" element={<Navigate to="/" replace />} /> */}
    </Routes>
  </BrowserRouter>

  );
};

export default App;